import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=3c8ab43e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8ab43e')) {
      api.createRecord('3c8ab43e', component.options)
    } else {
      api.reload('3c8ab43e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=3c8ab43e&", function () {
      api.rerender('3c8ab43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2geDea4EA5jrk/JS/pricehelp.vue"
export default component.exports